import { render, staticRenderFns } from "./PeriodsIndep.vue?vue&type=template&id=f35cdc06&"
import script from "./PeriodsIndep.vue?vue&type=script&lang=js&"
export * from "./PeriodsIndep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports